import React from 'react';
import { createSelectClassName } from './selectStyles';

type ControlProps = {
  value?: string;
  name?: string;
  invalid?: boolean;
  autoFocus?: boolean;
  disabled?: boolean;
  onValueChange(nextValue: string): void;
};

export const SelectControlComponent: React.FC<ControlProps> = (props) => {
  const {
    children,
    value,
    name,
    invalid,
    autoFocus,
    disabled,
    onValueChange,
  } = props;

  const className = createSelectClassName('wrapper', { invalid, disabled });

  const handleChange = React.useCallback(
    (event: React.SyntheticEvent<HTMLSelectElement>) => {
      onValueChange(event.currentTarget.value);
    },
    [onValueChange]
  );

  return (
    <select
      name={name}
      value={value}
      autoFocus={autoFocus}
      disabled={disabled}
      onChange={handleChange}
      className={className}
      data-invalid={invalid}
    >
      {children}
    </select>
  );
};

type OptionProps = {
  value: string;
  label?: string;
  disabled?: boolean;
};

export const SelectOptionComponent: React.FC<OptionProps> = (props) => {
  const { value, children, label, disabled } = props;

  const className = createSelectClassName('option');

  return (
    <option
      value={value}
      label={label}
      disabled={disabled}
      className={className}
    >
      {children}
    </option>
  );
};
